import React from "react";
import "./styles.css"

const chave = '@inovoline/noitedia' // 


function NoiteDia(){ 
  // colocar posteriomentes o componete botão noite/dia


  // carregando o menu de teste do NoiteDia
  if (true) {
    return (
      <div className="container">
        <p>`Voce esta com o modo Modo Noite ${String(get_NoiteDia())}`</p>
        <button type="submit" className="submitButton" onClick={set_noite}>Trocar para noite</button>
        <button type="submit" className="submitButton" onClick={set_dia}  >Trocar para dia</button>
      </div>
    );
  }
}


function set_noite(){
  
  localStorage.setItem(chave, true);

}
function set_dia(){

  localStorage.setItem(chave, false); 

}
function get_NoiteDia(){
  
  return (localStorage.getItem("@inovoline/noitedia") === 'true');
  
}


export {NoiteDia, set_noite, get_NoiteDia, set_dia}
export default NoiteDia